<template>
  <teleport to="body">
    <div @on-close="handleSmoothClose()">
      <div :class="['mobile-navigation__wrapper', { 'is-open': show }]">
        <section class="mobile-navigation">
          <div class="mobile-navigation__header">
            <p-icon
              icon="x-close-delete"
              color="fg-primary"
              class="cursor-pointer"
              size="sm"
              @click="handleSmoothClose()"
            />
          </div>
          <p-divider />
          <div class="mobile-navigation__content">
            <user-details selected @on-close="handleSmoothClose()" />
            <p-divider class="my-16" />
            <div v-for="{ to, title, prepend } in menuItems" :key="title">
              <nuxt-link :to="to" @click="itemClickHandler(to.path)">
                <p-list hover :title="title" :selected="isActive(to.path)">
                  <template #prepend>
                    <p-icon v-if="prepend" :icon="prepend" size="sm" color="fg-secondary" />
                  </template>
                  <template #append>
                    <p-icon
                      v-if="activeItem === to.path"
                      icon="caret-right"
                      size="xs"
                      color="highlight"
                    />
                  </template>
                </p-list>
              </nuxt-link>
            </div>
            <p-divider class="my-16" />
            <support-list @on-close="handleSmoothClose()" />
          </div>
          <slot />
          <p-bottom-sheet
            v-if="isOpen"
            show-close
            :title="$t('market.name')"
            @on-close="isOpen = false"
            @click.stop
          >
            <market-picker />
          </p-bottom-sheet>
        </section>
      </div>
    </div>
  </teleport>
</template>

<script setup lang="ts">
const emit = defineEmits(['on-close'])
const route = useRoute()
const show = ref(false)
const activeItem = ref('')
const isOpen = ref(false)

// Placeholder for the menu items the v-for above iterates. The real list
// was previously injected from a parent that no longer provides it; the
// template renders nothing in that case (Vue treats v-for over undefined
// as empty). Typed empty array keeps runtime behaviour and silences TS.
const menuItems: { to: { path: string }; title: string; prepend?: string }[] = []

const isActive = (path: string) => route.path === path

const itemClickHandler = (path: string) => {
  activeItem.value = path
  handleSmoothClose()
}

const handleSmoothClose = (): void => {
  show.value = false
  setTimeout(() => {
    emit('on-close')
  }, 300)
}

const handleSmoothOpen = (): void => {
  setTimeout(() => {
    show.value = true
  }, 100)
}

onMounted(() => {
  handleSmoothOpen()
})
</script>
